<template>
  <v-row justify="center">
    <modal v-model="show" :max-width="650" persistent>
      <div
        class="modal-title text-h6 grey--text text--darken-2 d-flex justify-center align-center"
      >
        Exclude
      </div>
      <v-container fluid>
        <div
          class="mb-2 grey--text text--darken-2 font-weight-bold text-body-2"
        >
          Please select why this reference should be excluded
        </div>
        <review-criteria-list
          v-if="hasExclusionCriteria"
          v-model="selectedCriteria"
          class="mb-2"
          :review-criteria="exclusionCriteria"
          criteria-type="EXCLUSION"
          allow-select
        />
        <div v-else class="text-body-2 pb-2">
          <div class="d-flex align-center pa-2">
            <v-icon class="mr-2" color="error">error</v-icon>
            <div>
              You must specify some exclusion criteria before electing
              to
              <strong>Exclude</strong>. Please go to the
              <router-link
                class="text-decoration-none font-weight-bold"
                :to="reviewSettingsUrl"
              >
                Review Settings
              </router-link>
              to resolve this issue.
            </div>
          </div>
        </div>
        <div
          v-if="!hideNotes"
          class="mb-2 grey--text text--darken-2 font-weight-bold text-body-2"
        >
          Notes
        </div>
        <v-textarea
          v-if="!hideNotes"
          v-model="notes"
          class="text-body-2"
          placeholder="Add a note..."
          outlined
          auto-grow
          hide-details
          :disabled="!hasExclusionCriteria"
        />
      </v-container>
      <template #actions>
        <action-button class="mr-3" @click="show = false">
          Cancel
        </action-button>
        <action-button
          color="success"
          :disabled="!valid"
          @click="onSave"
        >
          <v-icon left class="material-icons-outlined">save</v-icon>
          Save
        </action-button>
      </template>
    </modal>
  </v-row>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';
import ReviewCriteriaList from '@/components/ReviewSettingsPage/ReviewCriteriaList';
import { Review } from '@/models';

export default {
  name: 'NotRelevantReviewModal',
  components: { ActionButton, Modal, ReviewCriteriaList },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    review: {
      type: Review,
      required: true,
    },
    hideNotes: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'save'],
  data: () => ({
    selectedCriteria: null,
    notes: null,
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    valid() {
      return this.selectedCriteria !== null;
    },
    hasExclusionCriteria() {
      return this.exclusionCriteria.length > 0;
    },
    exclusionCriteria() {
      return this.review.exclusionCriteria();
    },
    reviewSettingsUrl() {
      return `/review/${this.review.id}/settings`;
    },
  },
  methods: {
    onSave() {
      this.show = false;
      this.$emit('save', {
        reviewCriteria: this.selectedCriteria,
        notes: this.notes,
      });
      this.selectedCriteria = null;
      this.notes = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.modal-title {
  width: 100%;
  min-height: 96px;
  border-bottom: 1px solid map-get($grey, 'lighten-2');
}
</style>
